import React from "react";
import * as Accordion from "@repo/ui/accordion";
import { Text } from "@repo/ui/text";
import { Small } from "@/components/viewport";
import { STRINGS } from "@/constants";
import {
  TYPOGRAPHY_LABEL3,
  TYPOGRAPHY_BODY3_BOLD,
  TYPOGRAPHY_BODY3_SENTENCE,
  TYPOGRAPHY_LINK2_CAPS,
} from "@/theme/topshop/typography/typography-constants";
import { CatalogueMappedProduct } from "@/utils/map-product-data";
import { DeliveryAndReturnsSheetView } from "@/views/delivery-and-returns";

export const buildCategoryUrl = ({ description }: { description: string }) => {
  const cidMatch = description.match(
    /<a [^>]*href="[^"]*\?[^"]*cid=(\d+)[^"]*"/,
  );
  const floorMatch = description.match(/href="\/([^/]+)\//);

  const cid = cidMatch ? cidMatch[1] : null;
  const floor = floorMatch ? floorMatch[1] : "women";
  const shop = floor === "women" ? "topshop" : "topman";

  const category = getCategoryFromDescription({ description })?.toLowerCase();
  const url = `/${shop}/category${category ? `/${category}` : ""}?cid=${cid}`;
  return url;
};

export const getCategoryFromDescription = ({
  description,
}: {
  description: string;
}) => {
  const match = description.match(/<strong>(.*?)<\/strong>/);
  const category = match ? match[1] : null;
  return category;
};

export const removeCategoryBrandStringFromDescription = ({
  description,
}: {
  description: string;
}) => {
  const lastAnchorIndex = description.lastIndexOf("</a>");

  const formattedDescription =
    lastAnchorIndex !== -1
      ? description.slice(lastAnchorIndex + 4)
      : description;

  return formattedDescription.replace(/^(<br\s*\/?>)+/gi, "");
};

export const ProductDetails = ({
  fullProductData,
  flexiSourceName,
}: {
  fullProductData: CatalogueMappedProduct;
  flexiSourceName?: string | null;
}) => {
  const {
    productCode,
    description,
    info: { aboutMe = "", careInfo = "" },
  } = fullProductData;

  return (
    <Accordion.Root defaultValue="product-details-2">
      <Accordion.Item value="product-details">
        <Accordion.Header>
          <Accordion.Trigger className={TYPOGRAPHY_LABEL3}>
            PRODUCT DETAILS
            <Accordion.TriggerIcon />
          </Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Content className={TYPOGRAPHY_BODY3_SENTENCE}>
          <div>
            <Text>ID: {productCode}</Text>
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: removeCategoryBrandStringFromDescription({
                  description,
                }),
              }}
            />
            <br />
            <Text dangerouslySetInnerHTML={{ __html: aboutMe }} />
            <br />
            <Text dangerouslySetInnerHTML={{ __html: careInfo }} />
          </div>
        </Accordion.Content>
      </Accordion.Item>
      <Accordion.Item value="product-details-2">
        <Accordion.Header>
          <Accordion.Trigger className={TYPOGRAPHY_LABEL3}>
            DELIVERY & RETURNS
            <Accordion.TriggerIcon />
          </Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Content className={TYPOGRAPHY_BODY3_SENTENCE}>
          <div>
            {flexiSourceName && (
              <Small>
                <Text className={TYPOGRAPHY_BODY3_SENTENCE}>
                  {STRINGS.deliveryAndReturns.accordion.flexiSourcePrefix}{" "}
                  <strong className={TYPOGRAPHY_BODY3_BOLD}>
                    {flexiSourceName}
                  </strong>
                </Text>
                <br />
              </Small>
            )}
            Free delivery on orders over £40.00. Standard delivery £4.50
            <br />
            Free returns on all orders.
            <br />
            <br />
            <DeliveryAndReturnsSheetView className={TYPOGRAPHY_LINK2_CAPS}>
              View Rates
            </DeliveryAndReturnsSheetView>
          </div>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};
